import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { OCCASIONS } from "../../data/presents";
import { setSiteSettingsCache, useSiteSettings, type SiteSettings } from "../../lib/siteSettings";
import { Panel } from "../PageShell";
import { PopButton } from "../PopButton";
import { FilterOptionToggles } from "./FilterOptionToggles";

const label = "block text-[11px] font-extrabold uppercase tracking-wide text-[#6b3a12]";

export function SiteSettingsBox() {
  const current = useSiteSettings();
  const [f, setF] = useState<SiteSettings | null>(current);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (current && !f) setF(current); }, [current, f]);
  if (!f) return null;
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put<SiteSettings>("/admin/settings", f);
      setSiteSettingsCache(data);
      toast.success("Site settings saved — live for visitors now");
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };
  return (
    <Panel className="!p-3">
      <div data-testid="admin-site-settings">
        <h2 className="font-comic text-xl text-[#FF5D1F]">Site settings</h2>
        <div className="mt-2 grid gap-2 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
          <label className={label}>Default occasion (gift finder)
            <select className="field mt-1 !py-2 !text-sm" value={f.default_occasion} onChange={(e) => setF({ ...f, default_occasion: e.target.value })} data-testid="admin-default-occasion-select">
              <option value="any">Any occasion</option>
              {OCCASIONS.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
            </select>
          </label>
          <label className={label}>Seasonal theme
            <select className="field mt-1 !py-2 !text-sm" value={f.theme} onChange={(e) => setF({ ...f, theme: e.target.value as SiteSettings["theme"] })} data-testid="admin-theme-select">
              <option value="none">Off (normal look)</option>
              <option value="christmas">Christmas</option>
            </select>
          </label>
          <PopButton tone="orange" size="sm" disabled={busy} onClick={save} data-testid="admin-settings-save-button">{busy ? "Saving…" : "Save settings"}</PopButton>
        </div>
        {f.disabled_options.occasions.includes(f.default_occasion) && (
          <p className="mt-1 text-xs font-bold text-[#C8102E]" data-testid="admin-default-occasion-warning">Default occasion is switched off — visitors will see "Any occasion".</p>
        )}
        <FilterOptionToggles value={f.disabled_options} onChange={(d) => setF({ ...f, disabled_options: d })} />
      </div>
    </Panel>
  );
}
